import axios from "axios";
import { getHeaders } from "services/AuthHeader";

const API_URL = process.env.REACT_APP_API_URL;

export interface CreditHistoryRI {
    // CASTKA: number
    // CDD: any
    // DATUM_POHYBU: Date
    // DATUM_UZDP: any
    // ID_CD: any
    // ID_KLIENT: number
    // ID_PLATBY: number
    // ID_POYBU: number
    // ID_RADEK: any
    // POPIS: string
    // ZALOZIL_KDE: string
    // ZALOZIL_KDO: number
    amount: number,
    date: Date,
    description: {
        detail: string,
        purchased_items: any[]
    }, 
}
export interface CreditHistoryI {
    amount: number,
    date: Date,
    description: {
        detail: string,
        purchased_items: any[]
    }, 
}

export async function getUserCreditHistoryService(client_id: any, page_number, page_size) {
    // console.log(API_URL);
    // console.log(page_number);
    // console.log(page_size);
    
    try {
        const response: any = await axios.get(
            API_URL + '/user/credit_history',
            {
                params: {
                    client_id: client_id,
                    page_number: page_number,
                    page_size: page_size
                },
                headers: getHeaders()
            }
        )
        // console.log("getUserCreditHistoryService Response".toUpperCase());    
        // console.log(response);

        if ('error' in response.data) {
            // console.log("error");
            
            throw Error
        }

        if (! ('credit_history' in response.data)) {
            // console.log("not data");
            
            throw Error
        }
        
        let credit_history: CreditHistoryI[] = JSON.parse(response.data.credit_history)
        // let credit_history: CreditHistoryI[] = json
        // let credit_history: CreditHistoryI[] = []
        // json.forEach((value: CreditHistoryRI) => {
        //     credit_history.push({
        //         date: value.DATUM_POHYBU,
        //         description: value.POPIS,
        //         price: value.CASTKA
        //     })
        // })

        // console.log("credit history json".toUpperCase());
        // console.log(credit_history);
        
        return credit_history

    } catch (error) {
        // console.log(error);
        
        return "credit_history_error"
    }

}